import Nagoyatv from './Nagoyatv'

export default Nagoyatv
